import classNames from 'classnames';
import FiltersIcon from 'components/svg/search/FiltersIcon';
import FiltersDogsIcon from 'components/svg/search/FiltersDogsIcon';
import FiltersHikingIcon from 'components/svg/search/FiltersHikingIcon';
import ListsIcon from 'components/svg/search/ListsIcon';
import MapsIcon from 'components/svg/search/MapsIcon';
import ParksIcon from 'components/svg/search/ParksIcon';
import PlacesIcon from 'components/svg/search/PlacesIcon';
import RecordingsIcon from 'components/svg/search/RecordingsIcon';
import TrailsIcon from 'components/svg/search/TrailsIcon';
import { AlgoliaHit, AlgoliaResultType } from 'types/Search/Algolia';
import * as styles from './styles/styles.module.scss';

export type Props = {
  isActive?: boolean;
  isSmallVariant?: boolean;
  result: AlgoliaHit;
};

function SearchResultIcon({ isActive, isSmallVariant, result }: Props) {
  const className = classNames({ [styles.activeSvg]: isActive, [styles.smallVariant]: isSmallVariant });

  switch (result.type) {
    case AlgoliaResultType.Trail:
      return <TrailsIcon className={className} />;
    case AlgoliaResultType.Track:
      return <RecordingsIcon className={className} />;
    case AlgoliaResultType.Place:
      return <PlacesIcon className={className} />;
    case AlgoliaResultType.List:
      return <ListsIcon className={className} />;
    case AlgoliaResultType.Area:
      return <ParksIcon className={className} />;
    case AlgoliaResultType.Map:
      return <MapsIcon className={className} />;
    case AlgoliaResultType.Filter:
      if (result.filters?.activity?.includes('hiking')) {
        return <FiltersHikingIcon className={className} />;
      }

      if (result.filters?.suitability?.includes('dogs')) {
        return <FiltersDogsIcon className={className} />;
      }

      return <FiltersIcon className={className} />;
    case AlgoliaResultType.POI:
      return <FiltersIcon className={className} />;
    default:
      return null;
  }
}

export default SearchResultIcon;
